import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import OpalHeading from '../../opal/OpalHeading'
import FadeIn from '../Transitions/FadeIn'
import ActivityDialog from './ActivityDialog'
import ActivityType from './ActivityType'
import EmptyType from './EmptyType'

function ActivityList ({
  activities,
  title,
  activityType,
  actions,
  className,
  style,
  itemClassName,
  itemStyle,
  component,
  componentProps,
  dialogComponent,
  dialogComponentProps,
  empty
}) {
  const dialogRef = useRef(null)

  if (!activities?.length) {
    return (
      <FadeIn className={className} style={style}>
        {title ? <OpalHeading>{title}</OpalHeading> : null}
        <EmptyType activityType={activityType} {...(empty || {})} />
      </FadeIn>
    )
  }

  return (
    <div className={className} style={style}>
      {title ? <OpalHeading>{title}</OpalHeading> : null}
      {activities?.map((activity) => (
        <ActivityType
          key={`activity_${activity.id}`}
          activityType={activityType}
          activity={activity}
          actions={actions}
          className={itemClassName}
          style={itemStyle}
          onClick={() => dialogRef.current.open(activity)}
          component={component}
          componentProps={componentProps}
        />
      ))}
      <ActivityDialog
        ref={dialogRef}
        activityType={activityType}
        component={dialogComponent}
        componentProps={dialogComponentProps}
      />
    </div>
  )
}

ActivityList.propTypes = {
  activities: PropTypes.array,
  title: PropTypes.string,
  activityType: PropTypes.oneOf(['activity', 'task', 'meeting', 'note']),
  actions: PropTypes.array,
  className: PropTypes.string,
  style: PropTypes.object,
  itemClassName: PropTypes.string,
  itemStyle: PropTypes.object,
  component: PropTypes.node,
  componentProps: PropTypes.object,
  dialogComponent: PropTypes.node,
  dialogComponentProps: PropTypes.object,
  empty: PropTypes.shape({
    message: PropTypes.string,
    icon: PropTypes.string,
    iconSize: PropTypes.number,
    className: PropTypes.string,
    style: PropTypes.object
  })
}

ActivityList.defaultProps = {
  activityType: 'activity',
  className: 'flex flex-col gap-sm'
}

export default ActivityList
